import React from 'react'

import t from '../../translations'

// Wygląd jak komunikaty ankiety (Container + Paper + Typography body2), ale ze zwykłych elementów HTML:
// ekran awaryjny nie może zależeć od komponentów, które mogły właśnie rzucić błąd.
const styles = {
  wrapper: {
    margin: '0 auto',
    maxWidth: 1112,
  },
  paper: {
    margin: '1.2rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    borderRadius: 4,
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
  },
}

// Najwyższy poziom aplikacji: błąd renderowania daje polski komunikat zamiast pustej strony (pusty #root).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('Błąd wyświetlania ankiety:', error, info && info.componentStack)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className={'ErrorBoundary'} style={styles.wrapper}>
        <div role={'alert'} style={styles.paper}>
          {t.pollView.renderError}
        </div>
      </div>
    )
  }
}

export default ErrorBoundary
